import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICashDeclaration } from "src/models/General/CashDeclaration.models";

interface cashDeclarationstate {
  cashDeclarations: ICashDeclaration[];
  cashDeclarationToEdit: ICashDeclaration | null;
}

const initialState: cashDeclarationstate = {
  cashDeclarations: [],
  cashDeclarationToEdit: null,
};

const cashDeclarationSlice = createSlice({
  name: "CashDeclaration",
  initialState,
  reducers: {
    setCashDeclarationList: (
      state,
      action: PayloadAction<ICashDeclaration[]>
    ) => {
      state.cashDeclarations = action.payload;
    },
    concatListCashDeclaration: (
      state: cashDeclarationstate,
      action: PayloadAction<ICashDeclaration[]>
    ) => {
      state.cashDeclarations = [
        ...state.cashDeclarations.concat(action.payload),
      ];
    },
    setCashDeclarationToEdit: (
      state,
      action: PayloadAction<ICashDeclaration | null>
    ) => {
      state.cashDeclarationToEdit = action.payload;
    },
    addCashDeclaration: (state, action: PayloadAction<ICashDeclaration>) => {
      state.cashDeclarations.push(action.payload);
    },
    updateCashDeclaration: (state, action: PayloadAction<ICashDeclaration>) => {
      let itemIndex = state.cashDeclarations.findIndex(
        item => item.cashDeclarationId === action.payload.cashDeclarationId
      );
      if (itemIndex !== -1) state.cashDeclarations[itemIndex] = action.payload;
    },
    deleteCashDeclaration: (state, action: PayloadAction<number>) => {
      const newArray = state.cashDeclarations.filter(
        item => item.cashDeclarationId !== action.payload
      );
      state.cashDeclarations = newArray;
    },
  },
});

export const {
  setCashDeclarationList,
  concatListCashDeclaration,
  setCashDeclarationToEdit,
  addCashDeclaration,
  updateCashDeclaration,
  deleteCashDeclaration,
} = cashDeclarationSlice.actions;

export default cashDeclarationSlice.reducer;
